import * as React from 'react';
import { SVGProps } from 'react';

const SvgDashedArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 81 8'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='m77.172.464 3.182 3.182a.5.5 0 0 1 0 .708l-3.182 3.182a.5.5 0 1 1-.707-.708L78.793 4.5H76v-1h2.793l-2.329-2.328a.5.5 0 1 1 .708-.708ZM4 4.5H0v-1h4v1Zm16 0h-8v-1h8v1Zm16 0h-8v-1h8v1Zm16 0h-8v-1h8v1Zm16 0h-8v-1h8v1Z'
      fill='#000'
    />
  </svg>
);

export default SvgDashedArrow;
